import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  constructor() {} // private userService: UserService

  public handleError(error: any): any {
    if (!error) {
      return error;
    }

    if (error.status === 401) {
      // this.userService.logout();
    }

    if (error) {
      const { message, status, code, decline_code } = error;
      let serverMessage: string | undefined;
      let serverDeclineCode: string | undefined;
      if (error.error && typeof error.error === 'object' && error.error.error) {
        serverMessage = error.error.error;
        serverDeclineCode = error.error.decline_code;
      } else if (typeof error.error === 'string') {
        serverMessage = error.error;
      }
      const _error = {
        message: serverMessage || message,
        status,
        code,
        decline_code: serverDeclineCode || decline_code,
        // Carried through from HttpErrorInterceptor (or a raw error body):
        // a sale 409 names the existing sale here.
        data: error.data !== undefined ? error.data : error.error?.data,
      };
      return _error;
    } else {
      return error;
    }
  }
}
